const SectionLabel: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div className="w-100 position-relative border my-4">
      {label && (
        <small className="position-absolute top-50 start-50 translate-middle bg-white text-nowrap text-secondary px-2">
          {label}
        </small>
      )}
    </div>
  );
};

export default SectionLabel;
